export default {
      id: "icon-film-reel-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-film-reel",
      toString: function () {
        return this.url;
      }
    }